import { render, staticRenderFns } from "./DetailItem.vue?vue&type=template&id=9d5b31fe&scoped=true&"
import script from "./DetailItem.vue?vue&type=script&lang=ts&"
export * from "./DetailItem.vue?vue&type=script&lang=ts&"
import style0 from "./DetailItem.vue?vue&type=style&index=0&id=9d5b31fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5b31fe",
  null
  
)

export default component.exports